import { specialColorLookup, specialColors } from '../../../views/shared/conformed/common/colors'
import { WidgetColorPicker } from './color-picker'
import { FloatingWidget } from './floating-widget'
import { WidgetInputBox } from './widget-input-box'

export interface WidgetInputColorFieldProps {
	value: string
	displayColor?: string
	onChange: (value: string) => void
	label?: string
	presets?: Array<{
		label: string
		value: string
		displayColor: string
	}>
	isGenerating?: boolean
	initialOpen?: boolean
}

function ColorPreview({ color }: { color: string }) {
	if (Object.values(specialColors).includes(color)) {
		return <>{specialColorLookup[color as keyof typeof specialColorLookup]}</>
	}

	return <>{color}</>
}

export function WidgetInputColorField(
	{ value, displayColor, onChange, label, presets, isGenerating = false, initialOpen = false }:
		WidgetInputColorFieldProps,
) {
	return (
		<div className="">
			<FloatingWidget
				initialOpen={initialOpen}
				widget={({}) => (
					<WidgetColorPicker
						color={value}
						displayColor={displayColor}
						onChange={onChange}
						presets={presets}
					/>
				)}
				label={label}
				isDisabled={isGenerating}
			>
				{({ active }) => (
					<WidgetInputBox className="flex items-center gap-2 w-full" isGenerating={isGenerating}>
						<div
							className="size-4 rounded"
							style={{
								backgroundColor: displayColor ?? value,
								boxShadow: 'inset 0 0 0 1px rgba(0, 0, 0, 0.1)',
							}}
						/>
						<span className="text-xs text-grey-600">
							<ColorPreview color={value} />
						</span>
						<div className="grow-1" />
						<svg
							xmlns="http://www.w3.org/2000/svg"
							fill="none"
							viewBox="0 0 10 10"
							id="Paint-Palette--Streamline-Micro"
							className="text-grey-300"
							height={10}
							width={10}
						>
							<path
								fill="currentColor"
								fillRule="evenodd"
								d="M5.775 0.047a5 5 0 1 0 0.652 9.768A1.123 1.123 0 0 0 7.24 8.61a1.192 1.192 0 0 0 -0.792 -1.039 0.885 0.885 0 0 1 0.278 -1.725l0.002 0h1.294a1.885 1.885 0 0 0 1.78 -2.516A5 5 0 0 0 5.775 0.047Zm0.587 2.893a0.862 0.862 0 1 1 -1.724 0 0.862 0.862 0 0 1 1.724 0Zm-2.16 1.724a0.862 0.862 0 1 1 -1.724 0 0.862 0.862 0 0 1 1.724 0Zm-0.39 3.219a0.664 0.664 0 1 0 0 -1.328 0.664 0.664 0 0 0 0 1.328Z"
								clipRule="evenodd"
								strokeWidth={1}
							/>
						</svg>
					</WidgetInputBox>
				)}
			</FloatingWidget>
		</div>
	)
}
